import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
import { ConsoleLog } from './log';
class ConsoleInterface extends BuiltinInterface {
}
class ConsoleValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'Console';
    }
}
export const add = (builtins) => {
    builtins.addInterface('Console', new ConsoleInterface());
    builtins.addGlobalMember('Console', 'log', new ConsoleLog());
    builtins.addValue('console', new ConsoleValue());
};

//# sourceMappingURL=index.js.map
